module.exports = __webpack_public_path__ + "static/media/van.17198359.svg";